import { render, staticRenderFns } from "./product-items.vue?vue&type=template&id=90cf24bc&"
import script from "./product-items.vue?vue&type=script&lang=js&"
export * from "./product-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports